export const HOMEPAGE_HEADER_RENDER_VARIANT_ID = "homepage-header";
export const HOMEPAGE_HEADER_RENDER_VARIANT_ID = "homepage-header";
